// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --pin-pos: 0%;
  --ion-color-primary-light: #aeb5dc;
  --ion-color-primary: #3f51b5;
  --pin-bg-width: 35px;
  --pin-bg-left-offset: -44px;
}

.range-container {
  padding-left: var(--d-spacing-single);
  padding-right: var(--d-spacing-single);
}

.range-title {
  font-weight: bold;
  text-align: center;
}

.pin {
  left: calc(var(--pin-pos));
  z-index: 2;
  position: relative; /* add this to enable absolute positioning of :before pseudo-element */
  display: block;
  margin-bottom: -8px;
  margin-left: -9px;
}

#pinWrapper {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  vertical-align: bottom;
  transform: translateX(calc(-50% + 9px));
  height: 52px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: -3px;
}

.pin:before {
  content: "";
  position: absolute;
  bottom: 0;
  left: calc(var(--pin-bg-left-offset) * -1);
  width: calc(var(--pin-bg-width));
  height: 8px;
  background-color: var(--ion-color-primary);
  z-index: -1; /* send the bar behind the pin */
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.range {
  display: inline-flex;
  width: 100%;
}

.bar {
  background-color: #aeb5dc;
  height: 8px;
}

.interval {
  width: 100%;
}

.gap .bar {
  background-color: white;
}

.range:not(:has(.interval:only-child)) .interval:last-of-type .labels:has(.label:only-child) {
  justify-content: flex-end;
  text-align: right;
}
.range:not(:has(.interval:only-child)) .interval:first-of-type .labels:has(.label:only-child) {
  justify-content: start;
}

.labels {
  margin-top: 8px;
  display: inline-flex;
  width: 100%;
  justify-content: space-around;
}
.labels .label {
  line-height: 1.1em;
  max-width: 100%;
}
.labels .label:only-child {
  justify-content: center;
}
.labels .label:first-child:not(:only-child) {
  justify-content: flex-start;
  margin-right: auto;
}
.labels .label:last-child:not(:only-child) {
  text-align: right;
}

.lesserSection .bar {
  background-color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/common/components/range-with-intervals/range-with-intervals.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,kCAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,qCAAA;EACA,sCAAA;AACJ;;AAEA;EACI,iBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,0BAAA;EACA,UAAA;EACA,kBAAA,EAAA,sEAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,uCAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,0CAAA;EACA,gCAAA;EACA,WAAA;EACA,0CAAA;EACA,WAAA,EAAA,gCAAA;EAEA,+BAAA;EACA,4BAAA;AAAJ;;AAGA;EACI,oBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAII;EACI,uBAAA;AADR;;AAOQ;EACI,yBAAA;EACA,iBAAA;AAJZ;AASQ;EACI,sBAAA;AAPZ;;AAYA;EACI,eAAA;EACA,oBAAA;EACA,WAAA;EACA,6BAAA;AATJ;AAWI;EACI,kBAAA;EACA,eAAA;AATR;AAYI;EACI,uBAAA;AAVR;AAaI;EACI,2BAAA;EACA,kBAAA;AAXR;AAcI;EACI,iBAAA;AAZR;;AAgBA;EACI,0CAAA;AAbJ","sourcesContent":[":root {\n    --pin-pos: 0%;\n    --ion-color-primary-light: #aeb5dc;\n    --ion-color-primary: #3f51b5;\n    --pin-bg-width: 35px;\n    --pin-bg-left-offset: -44px;\n}\n\n.range-container {\n    padding-left: var(--d-spacing-single);\n    padding-right: var(--d-spacing-single);\n}\n\n.range-title {\n    font-weight: bold;\n    text-align: center;\n}\n\n.pin {\n    left: calc(var(--pin-pos));\n    z-index: 2;\n    position: relative; /* add this to enable absolute positioning of :before pseudo-element */\n    display: block;\n    margin-bottom: -8px;\n    margin-left: -9px;\n}\n\n#pinWrapper {\n    font-size: 16px;\n    font-weight: bold;\n    text-align: center;\n    vertical-align: bottom;\n    transform: translateX(calc(-50% + 9px));\n    height: 52px;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: -3px;\n}\n\n.pin:before {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: calc(var(--pin-bg-left-offset) * -1);\n    width: calc(var(--pin-bg-width));\n    height: 8px;\n    background-color: var(--ion-color-primary);\n    z-index: -1; /* send the bar behind the pin */\n\n    border-bottom-right-radius: 4px;\n    border-top-right-radius: 4px;\n}\n\n.range {\n    display: inline-flex;\n    width: 100%;\n}\n\n.bar {\n    background-color: #aeb5dc;\n    height: 8px;\n}\n\n.interval {\n    width: 100%;\n}\n\n.gap {\n    .bar {\n        background-color: white;\n    }\n}\n\n.range:not(:has(.interval:only-child)) {\n    .interval:last-of-type {\n        .labels:has(.label:only-child) {\n            justify-content: flex-end;\n            text-align: right;\n        }\n    }\n\n    .interval:first-of-type {\n        .labels:has(.label:only-child) {\n            justify-content: start;\n        }\n    }\n}\n\n.labels {\n    margin-top: 8px;\n    display: inline-flex;\n    width: 100%;\n    justify-content: space-around;\n\n    .label {\n        line-height: 1.1em;\n        max-width: 100%;\n    }\n\n    .label:only-child {\n        justify-content: center;\n    }\n\n    .label:first-child:not(:only-child) {\n        justify-content: flex-start;\n        margin-right: auto;\n    }\n\n    .label:last-child:not(:only-child) {\n        text-align: right;\n    }\n}\n\n.lesserSection .bar {\n    background-color: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
